import React from "react";
import { LOGIN_URL } from '../../helpers/constants/Constants';
import oneLogo from '../../assets/logos/one-logotype.svg';
import awLogo from '../../assets/logos/aw-logotype.svg';

export default class LoginAutodesk extends React.Component {

  forgeSignIn = () => {
    fetch(LOGIN_URL)
      .then(res => res.text())
      .then((rootUrl) => {
        console.log("UTL:", rootUrl)
        window.location.href = (rootUrl)//rootUrl;
      })
      .catch(console.log)
  }

  render() {
    return (
      <>
        <div className='container'>
          <div className='row'>
            <div className='col'>

              <div className='card'>
                <div className='card-body'>
                  <h1>Project Viewer</h1>
                  <p>Welcome to the @one Alliance Project Viewer. <a target="_blank"href='/Read_more.pdf'>Read more</a> about the Project Viewer.</p>
                </div>
                <div className='signin'>
                  <button className='btn btn-primary btn-lg btn-block' onClick={this.forgeSignIn} style={{cursor: "pointer"}}>Sign in</button>
                </div>
                <div className='card-footer'>
                  <img className='logo' src={oneLogo} alt='One Alliance' />
                  <img className='aw-logo' src={awLogo} alt='Anglian Water' />
                </div>
              </div>

            </div>
          </div>
        </div>
      </>
    )
  }
}
